import React, { useEffect } from 'react';
import { useLocalStorage } from 'react-use';

import { NEXT_REVIEW_AT } from './Review';

const useNextCourseReview = ({ courseCode }) => {
  // skooldio_next_review_at is a condition to show next round of review modal
  // default of skooldio_next_review_at is progress 50 percent
  const [nextReviewAt, setNextReviewAt] = useLocalStorage('skooldio_next_review_at', {});

  useEffect(() => {
    if (courseCode !== '' && courseCode !== undefined) {
      if (!nextReviewAt[courseCode]) {
        setNextReviewAt({
          ...nextReviewAt,
          [courseCode]: NEXT_REVIEW_AT.PROGRESS_80,
        });
      }
    }
  }, [courseCode]);

  const currentNextReviewAt = nextReviewAt[courseCode];

  const updateNextReviewAt = (nextReview) => {
    setNextReviewAt({ ...nextReviewAt, [courseCode]: nextReview });
  };

  return [currentNextReviewAt, updateNextReviewAt];
};

export default useNextCourseReview;
